import settingsModule from '../../settings.module';

class ScimService {
    constructor($q, authenticationService, scimApiService) {
        this.$q = $q;
        this.authenticationService = authenticationService;
        this.scimApiService = scimApiService;
    }

    getScimConfiguration() {
        const promise = this.authenticationService.getToken().then(cloudToken => {
            return this.scimApiService.getScimConfiguration(cloudToken);
        });

        return promise;
    }

    setScimConfiguration(config) {
        const promise = this.authenticationService.getToken().then(cloudToken => {
            return this.scimApiService.setScimConfiguration(cloudToken, config);
        });

        return promise;
    }

    generateNewBearerToken() {
        let deferred = this.$q.defer();

        this.authenticationService.getToken().then(cloudToken => {
            this.scimApiService.generateNewBearerToken(cloudToken).then(newTokenObj => {
                deferred.resolve(newTokenObj.token);
            }, deferred.reject);
        });

        return deferred.promise;
    }
}

export default settingsModule.service('scimService', ScimService);



// WEBPACK FOOTER //
// ./modules/settings/services/scim/scim.service.js